



const isElectron = () => {
    return window.electronAPI !== undefined;
};


export const getAlertStatsAsync = async () => {
    if (isElectron()) {
        try {
            const result = await window.electronAPI.alert.getStats();
            if (result.success) {
                return result.data;
            }
        } catch (error) {
            console.error('Error fetching alert stats:', error);
        }
    }

    return { total: 0, unread: 0, critical: 0, warning: 0, info: 0 };
};


export const getAlertStats = () => {

    return { total: 0, unread: 0, critical: 0, warning: 0, info: 0 };
};


export const getAlertsByLoanAsync = async (loanId) => {
    if (isElectron()) {
        try {
            const result = await window.electronAPI.alert.getAll({ loanId, isArchived: false });
            if (result.success) {
                return result.data || [];
            }
        } catch (error) {
            console.error('Error fetching alerts by loan:', error);
        }
    }
    return [];
};


export const getAlertsByLoan = (loanId) => {

    return [];
};


export const getPortfolioStatsAsync = async () => {
    if (isElectron()) {
        try {
            const result = await window.electronAPI.loan.getStats();
            if (result.success) {
                const stats = result.data;
                return {
                    totalLoans: stats.totalLoans || 0,
                    totalValue: stats.totalAmount || 0,
                    currency: 'EUR',
                    atRisk: (stats.atRiskCovenants || 0) + (stats.breachedCovenants || 0),
                    critical: stats.breachedCovenants || 0,
                    warning: stats.atRiskCovenants || 0,
                    ok: stats.compliantCovenants || 0,
                    complianceRate: stats.complianceRate || 100,
                    avgMaturity: 'N/A',
                    avgDaysToMaturity: 0,
                    activeCovenants: stats.activeCovenants || 0,
                    unreadAlerts: stats.unreadAlerts || 0,
                };
            }
        } catch (error) {
            console.error('Error fetching portfolio stats:', error);
        }
    }

    return {
        totalLoans: 0,
        totalValue: 0,
        currency: 'EUR',
        atRisk: 0,
        critical: 0,
        warning: 0,
        ok: 0,
        complianceRate: 100,
        avgMaturity: 'N/A',
        avgDaysToMaturity: 0,
        activeCovenants: 0,
        unreadAlerts: 0,
    };
};


export const getPortfolioStats = () => {

    return {
        totalLoans: 0,
        totalValue: 0,
        currency: 'EUR',
        atRisk: 0,
        critical: 0,
        warning: 0,
        ok: 0,
        complianceRate: 100,
        avgMaturity: 'N/A',
    };
};


export const portfolioStats = getPortfolioStats();


export const getStatusColor = (status) => {
    const colors = {
        ok: { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-200' },
        warning: { bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-200' },
        critical: { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-200' },
        info: { bg: 'bg-blue-100', text: 'text-blue-700', border: 'border-blue-200' },
        active: { bg: 'bg-emerald-100', text: 'text-emerald-700', border: 'border-emerald-200' },
        archived: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200' },
        closed: { bg: 'bg-slate-100', text: 'text-slate-700', border: 'border-slate-200' },
    };
    return colors[status] || colors.ok;
};


export const formatCurrency = (amount, currency = 'EUR') => {
    if (amount >= 1000000000) {
        return `€${(amount / 1000000000).toFixed(1)}B`;
    }
    if (amount >= 1000000) {
        return `€${(amount / 1000000).toFixed(0)}M`;
    }
    return new Intl.NumberFormat('en-EU', {
        style: 'currency',
        currency,
    }).format(amount);
};


export const formatDate = (dateString, locale = 'en-GB') => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
};


export const daysUntil = (dateString) => {
    if (!dateString) return null;
    const today = new Date();
    const target = new Date(dateString);
    return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
};